import Check from '@mui/icons-material/Check';
import { ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Typography } from '@mui/material';
import * as React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { CspImageList } from '../ui/CspImageList';
import { MarketingAnchor } from './MarketingMenu';
import { StyledTitleRow } from './StyledTitle';

export const Marketing04_domy = () => {
    const images = [
        { img: './img/Wizki/Taras_3.png', title: '', },
        { img: './img/Wizki/salon_1.png', title: '', },
        { img: './img/Wizki/biuro_1.png', title: '', },
        { img: './img/Wizki/Inwestycja_1.jpg', title: '', },
        { img: './img/Wizki/pokoj_2.PNG', title: '', },
        { img: './img/Wizki/salon_2.png', title: '', },
        { img: './img/Wizki/pokoj_1.PNG', title: '', },
        { img: './img/Wizki/1_2025_09_29.png', title: '', },
        { img: './img/Wizki/7_2025_09_29.png', title: '', },
        { img: './img/Wizki/pokoj_3.png', title: '', },
        { img: './img/Wizki/12_2025_09_29.png', title: '', },
        { img: './img/Wizki/6_2025_09_29.png', title: '', },
    ];
    const atuty1 = [
        { title: 'Jasne wnętrza', text: 'zapewniane przez duże przeszklenia', icon: 'architektura.png' },
        { title: 'Ustawne pokoje', text: 'aż cztery sypialnie', icon: 'plan.png' },
        { title: 'Otwarta kuchnia', text: 'połączona z jadalnią i salonem', icon: 'eko.png' },
        { title: 'Salon', text: 'z możliwością montażu kominka', icon: 'eko.png' },
        { title: 'Zadaszony taras', text: 'pięknie dopełniający salon', icon: 'eko.png' },
    ];
    const atuty2 = [
        { title: 'Ogród', text: 'oaza piękna i spokoju', icon: 'eko.png' },
        { title: 'Garaż', text: 'w bryle budynku', icon: 'eko.png' },
        { title: 'Poddasze', text: 'przestrzeń do przechowywania', icon: 'magazyn.png' },
        { title: 'Ogrzewanie podłogowe', text: 'w całym domu', icon: 'ogrzewanie.png' },
        { title: 'Spiżarnia', text: 'dodatkowa przestrzeń do przechowywania przy kuchni', icon: 'eko.png' },
    ];
    const cechy = [
        { title: 'Powierzchnia domu', text: '140m²', icon: 'n_powierzchnia.PNG' },
        { title: 'Ilość pokoi', text: '5', icon: 'n_ilosc_pokoi.PNG' },
        { title: 'Garaż', text: '17m²', icon: 'n_garaz.PNG' },
        { title: 'Działka', text: 'ok. 330m²', icon: 'n_ogrod.PNG' },
        { title: 'Zadaszony taras i balkon ', text: '27m²', icon: 'n_taras.PNG' },
    ];

    return (
        <>
            <Container>
                <MarketingAnchor id="domy" />

                <StyledTitleRow text="Etap 1" />
                <StyledTitleRow text="Dom - segment bliźniaka" />
                <Row className="my-3">
                    <Col />
                    <Col className="col-auto">
                        <Typography variant="subtitle1" align="justify" >
                            Prezentujemy Państwu domy, które zostały <b>starannie zaprojektowane</b> z myślą o komforcie i wygodzie ich użytkowania.
                            <br />
                            <br />
                            Przestronny układ wnętrz obejmuje <b>otwartą strefę dzienną</b> łączącą kuchnię, jadalnię i salon.
                            <b> Duże przeszklenia</b> wprowadzają do środka naturalne światło, a <b>ustawne pokoje</b> pozwalają na dowolną aranżację – tak, aby dom idealnie odpowiadał potrzebom mieszkańców.
                            <br />
                            <br />
                            Każdy z domów posiada <b>piękny zadaszony taras  i prywatny ogród</b>, które stanowią naturalne przedłużenie przestrzeni salonu.
                            <br />
                            <br />
                            Dodatkowo, w bryle budynku znajduje się <b>garaż</b>, a przed nim wygodne miejsce postojowe. Do dyspozycji mieszkańców pozostaje także poddasze, które można zagospodarować według własnych potrzeb.
                            <br />
                        </Typography>
                    </Col>
                    <Col />
                </Row>

                <Row className="pb-3">
                    {cechy.map((m, i) =>
                        <Col key={m.title} xs={6} lg={2} className="m-0 mb-1 p-0">
                            <Paper elevation={3} className="p-3 mx-2 h-100">
                                <img src={`./img/ikony/${m.icon}`} height="50" alt="ico" className="mx-auto d-block" />
                                <Typography variant="subtitle2" align="center" className="my-3">
                                    <b>{m.title}</b>
                                    <br />
                                    {m.text}
                                </Typography>
                            </Paper>
                        </Col>
                    )}
                </Row>
                <Row className="mt-3">
                    <Col >
                        <Paper elevation={12}>
                            <CspImageList items={images} />
                        </Paper>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col xs={12} md={6}>
                        <Paper sx={{}}>
                            <MenuList>
                                {atuty1.map((m, i) =>
                                    <MenuItem key={m.title}>
                                        <ListItemIcon>
                                            <Check />
                                        </ListItemIcon>
                                        <ListItemText primary={m.title}
                                            secondary={m.text}
                                            secondaryTypographyProps={{ variant: "subtitle2" }}
                                        />
                                    </MenuItem>
                                )}
                            </MenuList>
                        </Paper>
                        <br />
                    </Col>
                    <Col xs={12} md={6}>
                        <Paper sx={{}}>
                            <MenuList>
                                {atuty2.map((m, i) =>
                                    <MenuItem key={m.title}>
                                        <ListItemIcon>
                                            <Check />
                                        </ListItemIcon>
                                        <ListItemText primary={m.title}
                                            secondary={m.text}
                                            secondaryTypographyProps={{ variant: "subtitle2" }}
                                        />
                                    </MenuItem>
                                )}
                            </MenuList>
                        </Paper>
                        <br />
                    </Col>
                </Row>
            </Container >
        </>
    );
};
